import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
const app = createApp(App);

import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import 'vuetify/styles'
import {createVuetify} from "vuetify/framework";
import { mdi } from 'vuetify/iconsets/mdi'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import VueApexCharts from "vue3-apexcharts";
const vuetify = createVuetify({
    components,
    directives,
    icons: {
        sets: { mdi },
        defaultSet: 'mdi', // Ensure MDI is the default icon set
    },
    theme: {
        defaultTheme: 'light',
    },
});
app.use(VueApexCharts)
app.component('VueDatePicker', VueDatePicker);
app.component("ApexChart", VueApexCharts);
app.use(router);
app.use(vuetify);
app.mount('#app');